import { useEffect, useState } from 'react';

import { requestIosAttPermission } from '../analytics/att/requestIosAttPermission';
import { initAppsFlyer } from '../analytics/appsflyer/client';

/**
 * Resolves iOS ATT (no-op on web/Android), then unlocks tracking consumers
 * and initialises AppsFlyer. Returns `trackingReady` for gating GTM/Snowplow.
 */
export function useTrackingBootstrap(): boolean {
  const [trackingReady, setTrackingReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      await requestIosAttPermission();
      if (cancelled) return;

      setTrackingReady(true);
      await initAppsFlyer();
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return trackingReady;
}
